/*
 * @Author: zhangyue zhang_y1222@163.com
 * @Date: 2022-04-15 10:05:58
 * @LastEditors: zhangyue zhang_y1222@163.com
 * @LastEditTime: 2025-03-12 09:23:59
 * @FilePath: \kqcw_web\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import wx from 'weixin-js-sdk'
import {
    Toast,
    Dialog
} from 'vant';
// rem
import "amfe-flexible";
import App from "./App.vue";
import "@/assets/style/font/iconfont.less";
import "@/assets/style/index.less";
import * as $axios from "@/utils/request";
import mixin from "./mixin/index";
import store from "./store/index";
import "@/components/Vant";
import '@/utils/index'
import router from "./router/index";
import {
    getUrlParamsCode
} from '@/utils/'
import {
    getWXcode,
    getOpenId,
    getOpenIdEnable,
    getUserRole
} from '@/api/'
import { Base64 } from 'js-base64';
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

import NProgress from 'nprogress' // progress bar
router.beforeEach((to, from, next) => {
    // start progress bar
    NProgress.start()

    // set page title
    document.title = to.meta.title
    const rhzx = store.getters.rhzx
    const userInfo = store.getters.userInfo
    let authType = 1
    if (getUrlParamsCode(window.location.href).authType) {
        authType = getUrlParamsCode(window.location.href).authType
        store.commit(
            'updateAuthType',
            parseInt(getUrlParamsCode(window.location.href).authType)
        )
    } else {
        authType = store.getters.authType
    }
    if (getUrlParamsCode(window.location.href).rhzxflag) {
        // rhzx 跳转过来的
        if (rhzx === 'rhzx' && Base64.decode(getUrlParamsCode(window.location.href).rhzxuser).substring(0, 11) === userInfo.phoneNum) {
            next()
            NProgress.done()
        } else {
            store.commit('updateRhzx', 'rhzx')
            console.log()
            getUserRole({
                phoneNum: Base64.decode(getUrlParamsCode(window.location.href).rhzxuser).substring(0, 11)
            }).then(res => {
                if (res.code === 200) {
                    if (res.data) {
                        store.commit('updateUserInfo', res.data)
                        next()
                    }
                }
            })
        }
    } else if (getUrlParamsCode(window.location.href).businessId) {
        next()
        NProgress.done()
    } else {
        if (rhzx === 'rhzx') {
            next()
            NProgress.done()
        } else {
            // determine whether the user has openId
            const hasOpenId = store.getters.openId
            const bindOpenId = store.getters.bindOpenId
            if (hasOpenId) {
                if (bindOpenId) {
                    next()
                    NProgress.done()
                } else {
                    // 判断openId 是否绑定  如果未绑定 跳转到登录页面
                    getOpenIdEnable({
                        openId: hasOpenId,
                        authType: authType,
                    }).then(res => {
                        if (res.code === 200) {
                            if (!res.data) {
                                if (to.path !== '/') {
                                    next('/')
                                    NProgress.done()
                                } else {
                                    next()
                                    NProgress.done()
                                }
                            } else {
                                store.commit('updateBindOpenId', res.data)
                                next()
                                NProgress.done()
                            }
                        }
                    })
                }
            } else {
                /* has no openId*/
                if (process.env.NODE_ENV === 'production') {
                    if (!!!getUrlParamsCode(window.location.href, 'code')) {
                        window.location.href = getWXcode(window.location.href).weiXinCodeUrl
                    } else {
                        getOpenId({
                            code: getUrlParamsCode(window.location.href, 'code'),
                        })
                            .then(res => {
                                if (res.code === 200) {
                                    store.commit('updateOpenId', res.data)
                                    console.log('设置完openId  存储并跳转至首页')
                                    next('/')
                                    NProgress.done()
                                }
                            })
                            .catch(error => {
                                Toast('授权失败，请重新进入')
                                WeixinJSBridge.call('closeWindow')

                            })
                    }
                    // var ua = navigator.userAgent.toLowerCase();
                    // if (ua.match(/MicroMessenger/i) == "micromessenger") {

                    // } else {

                    //     // store.commit('updateOpenId', '123456')
                    //     // next('/')
                    //     // NProgress.done()
                    // }

                } else {
                    console.log('测试环境')
                    store.commit('updateOpenId', '123456')
                    next('/')
                    NProgress.done()
                }
            }
        }

    }

})


router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})

NProgress.configure({
    showSpinner: false
}) // NProgress Configuration




Toast.setDefaultOptions({
    duration: 5000
});
// 把变量挂载到vue的原型上
Vue.prototype.$axios = $axios;
Vue.prototype.$Toast = Toast
Vue.prototype.$Dialog = Dialog
// Vue.prototype.$echarts = echarts;
Vue.prototype.$wx = wx;
Vue.mixin(mixin);

Vue.config.productionTip = false;

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount("#app");